import React, { useState } from 'react';
import { login } from '../../utils/api';
import { useNavigate } from 'react-router-dom';

const LoginForm = () => {
    const [credentials, setCredentials] = useState({ username: '', password: '' });
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const res = await login(credentials);
        if (res.data.success) window.location.reload();
    };

    return (
        <div className='w-full max-w-md mx-auto min-h-screen flex justify-center items-center p-4'>
            <form onSubmit={handleSubmit} className="w-full p-5 sm:p-6 md:p-8 bg-white shadow-md border rounded-lg">
                <h3 className='text-xl sm:text-2xl mb-5 sm:mb-6 font-semibold text-center'>
                    Login to Dashboard
                </h3>
                <input
                    type="text"
                    placeholder="Username"
                    value={credentials.username}
                    onChange={e => setCredentials({ ...credentials, username: e.target.value })}
                    className="border p-2.5 sm:p-3 w-full mb-3 sm:mb-4 rounded text-sm sm:text-base"
                    required
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={credentials.password}
                    onChange={e => setCredentials({ ...credentials, password: e.target.value })}
                    className="border p-2.5 sm:p-3 w-full mb-4 sm:mb-5 rounded text-sm sm:text-base"
                    required
                />
                <button type="submit" className="bg-blue-500 hover:bg-blue-600 text-white p-2.5 sm:p-3 w-full rounded text-sm sm:text-base font-medium">Login</button>
            </form>
        </div>
    );
};

export { LoginForm };